import { api, ApiError } from "../api.js";
import { esc, avatarHtml, displayName, toast } from "../utils.js";
import { postCardHtml, attachPostCardHandlers } from "../postCard.js";
import { getCurrentUser, logout } from "../auth.js";
import { navigate } from "../app.js";
import { infiniteScroll } from "../infiniteScroll.js";

export async function render(container, params) {
  const me = getCurrentUser();
  const userId = params.id ? Number(params.id) : me?.id;
  const isMe = me && userId === me.id;

  if (!userId) {
    navigate("/login");
    return;
  }

  container.innerHTML = `<div class="text-center py-5"><div class="spinner-border text-primary"></div></div>`;

  let user;
  try {
    user = await api.get(`/users/${userId}`);
  } catch (err) {
    container.innerHTML = `<div class="dc-empty"><i class="bi bi-exclamation-triangle"></i><div>Diver not found.</div></div>`;
    return;
  }

  // The header re-renders (following them changes it); their posts are paged in
  // once, by author, however far back they go.
  container.innerHTML = `
    <div id="profile-header"></div>
    <hr />
    <h2 class="h5 mb-3">Posts</h2>
    <div id="profile-posts"></div>`;
  const header = container.querySelector("#profile-header");
  infiniteScroll(container.querySelector("#profile-posts"), {
    path: "/posts",
    query: { author_id: userId },
    emptyMessage: "No posts yet.",
    render: (list, posts) => {
      const batch = document.createElement("div");
      batch.innerHTML = posts.map(postCardHtml).join("");
      attachPostCardHandlers(batch);
      list.append(batch);
    },
  });

  function renderAll() {
    const name = displayName(user);
    header.innerHTML = `
      <div class="text-center mb-4">
        ${avatarHtml(name, { className: "dc-avatar-lg mx-auto mb-3" })}
        <h1 class="display-heading h4 mb-0">${esc(name)}</h1>
        <div class="text-slate">@${esc(user.username)}</div>
        ${user.certification_level ? `<span class="badge text-bg-light border mt-2"><i class="bi bi-award me-1"></i>${esc(user.certification_level)}</span>` : ""}
        <div class="d-flex justify-content-center gap-4 mt-3">
          <div><div class="fw-bold fs-5">${user.follower_count ?? 0}</div><div class="text-slate small">Followers</div></div>
          <div><div class="fw-bold fs-5">${user.following_count ?? 0}</div><div class="text-slate small">Following</div></div>
        </div>
        <!-- Left-aligned, unlike the rest of the centred header: a
             description keeps its line breaks and indentation, and
             centring would make both meaningless. Constrained so a long
             line does not run the width of a desktop window. -->
        ${user.bio
          ? `<p class="mt-3 mb-0 dc-user-text text-start mx-auto" style="max-width:42rem;">${esc(user.bio)}</p>`
          : ""}
        <div class="mt-3" id="profile-action"></div>
      </div>`;

    const actionEl = header.querySelector("#profile-action");
    if (isMe) {
      actionEl.innerHTML = `
        <div class="d-flex justify-content-center gap-2">
          <a href="#/profile/edit" class="btn btn-outline-secondary"><i class="bi bi-pencil me-1"></i>Edit Profile</a>
          <button class="btn btn-outline-secondary" id="logout-btn"><i class="bi bi-box-arrow-right me-1"></i>Log out</button>
        </div>`;
      actionEl.querySelector("#logout-btn").addEventListener("click", () => {
        logout();
        navigate("/login");
      });
    } else {
      const following = user.is_following;
      actionEl.innerHTML = following
        ? `<button class="btn btn-outline-primary" id="follow-btn"><i class="bi bi-check-lg me-1"></i>Following</button>`
        : `<button class="btn btn-primary" id="follow-btn"><i class="bi bi-person-plus me-1"></i>Follow</button>`;
      actionEl.querySelector("#follow-btn").addEventListener("click", async () => {
        const btn = actionEl.querySelector("#follow-btn");
        btn.disabled = true;
        try {
          user = await api.post(`/users/${userId}/${following ? "unfollow" : "follow"}`);
          renderAll();
        } catch (err) {
          toast(err instanceof ApiError ? err.message : "Something went wrong.", "danger");
          btn.disabled = false;
        }
      });
    }
  }

  renderAll();
}
